import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import TabsWithTablesLayout from 'src/components/Layout/TabsWithTablesLayout';
import { useTenantContext } from 'src/context/useTenantContext';

interface IssuesPageProps {}

const IssuesPage = React.memo((_: IssuesPageProps) => {
  const { t } = useTranslation();
  const { buildPath } = useTenantContext();
  const routes = [
    {
      label: t('common.allIssues'),
      url: buildPath('issues/all'),
    },
    {
      label: t('common.employeeIssues'),
      url: buildPath('issues/employee'),
    },
    {
      label: t('common.dishIssues'),
      url: buildPath('issues/dish'),
    },
    {
      label: t('common.operationIssues'),
      url: buildPath('issues/operation'),
    },
  ];
  return (
    <TabsWithTablesLayout routes={routes} title={t('common.issues')}>
      <Outlet />
    </TabsWithTablesLayout>
  );
});

export default IssuesPage;
